module.exports = __webpack_public_path__ + "img/74f2d14.svg";